import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ignoreError } from '~/infra/utils';
let appcuesBlocked = false;
export function setAppcuesBlocked(blocked) {
    appcuesBlocked = blocked;
}
export const appcues = {
    identify (userId, userEmail, userProperties) {
        if (appcuesBlocked) return;
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.identify(userId, _object_spread_props(_object_spread({}, userProperties), {
                email: userEmail
            }));
        });
    },
    sendEventDeprecated (eventName, _eventData) {
        if (appcuesBlocked) return;
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.track(eventName);
        });
    },
    report (eventType, eventName) {
        if (appcuesBlocked) return;
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.track(getEventNameWithProperties(eventType, eventName));
        });
    },
    sendPageView (_url, _eventData) {
        if (appcuesBlocked) return;
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.page();
        });
    }
};
const getEventNameWithProperties = (eventType, eventName)=>"".concat(eventType, "-").concat(eventName);
